export const CaretRight = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width={20} height={21}>
		<g id="Caret_Right">
			<path
				id="icon"
				d="M8.0876 5.25012L6.9126 6.42512L10.7293 10.2501L6.9126 14.0751L8.0876 15.2501L13.0876 10.2501L8.0876 5.25012Z"
				fill="#7D7D7A"
			/>
		</g>
	</svg>
);
